import { Box } from "@mui/material";
import LeaveApprovalsList from "./List";

export default function LeaveApprovalsIndex() {
    return (
        <Box width="100%">
            <LeaveApprovalsList />
        </Box>
    )
}